import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    startMigrationTitle: {
        id: 'migration.modal.start_migration.title',
        defaultMessage: 'Nice to meet you, Freewallet user!',
    },
    startMigrationSubtitle: {
        id: 'migration.modal.start_migration.subtitle',
        defaultMessage:
            'To unlock the full potential of the {brokerName} app, please pass the KYC verification process',
    },
    startMigrationButtonText: {
        id: 'migration.modal.start_migration_button.text',
        defaultMessage: 'Start verification',
    },
    signOutButtonText: {
        id: 'migration.modal.start_migration_sign_out_button.text',
        defaultMessage: 'Sign out',
    },
})
